/**
 * CWR 2.2 — the catalog's page-owned header (rendered into the ClientShell
 * header slot): back button + centered title/subtitle + glass Services/Events
 * segmented tabs. Copied from the confirmed mockup.
 */
import { BackIcon } from './catalogIcons';
import styles from './BookSessionPage.module.css';

export type CatalogTab = 'services' | 'events';

export interface CatalogHeaderProps {
  activeTab: CatalogTab;
  onTabChange: (tab: CatalogTab) => void;
  onBack: () => void;
}

export function CatalogHeader({ activeTab, onTabChange, onBack }: CatalogHeaderProps) {
  return (
    <>
      <div className={styles.pageHeaderSection}>
        <button type="button" className={styles.pageBackBtn} onClick={onBack} aria-label="Back">
          {BackIcon}
        </button>
        <div className={styles.pageTitleBlock}>
          <h1 className={styles.pageTitle}>Book a Session</h1>
          <p className={styles.pageSubtitle}>Choose a service or join a scheduled event.</p>
        </div>
      </div>
      <div className={styles.tabSegmented} role="tablist" aria-label="Catalog">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === 'services'}
          className={`${styles.tabSegment} ${activeTab === 'services' ? styles.active : ''}`}
          onClick={() => onTabChange('services')}
        >
          Services
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === 'events'}
          className={`${styles.tabSegment} ${activeTab === 'events' ? styles.active : ''}`}
          onClick={() => onTabChange('events')}
        >
          Events
        </button>
      </div>
    </>
  );
}
